export default "__VITE_ASSET__BAT6lFNM__"